import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryPurchaseOrderDraftPropsBody } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useInventoryPurchaseOrderPdfAPI = () => {
  const [pdfView, setpdfView] = useState(null);

  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const downloadPDF = useCallback(() => {
    const link = document.createElement("a");
    console.log(link);
    link.href = pdfView;
    link.download = "downloaded.pdf"; // Specify the desired filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, [pdfView]);
  const execute = useCallback(
    async (data: IInventoryPurchaseOrderDraftPropsBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .post(`${INVENTORY_MODULE?.PURCHASE_ORDER_PDF?.baseURL}`, data, {
            responseType: "arraybuffer",
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            const blob = new Blob([res.data], { type: "application/pdf" });
            const pdfUrl = window.URL.createObjectURL(blob);
            setpdfView(pdfUrl);
            return res;
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e)
            return null;
          });
        return response;
      } catch (error) {
        console.error("Error downloading the PDF:", error);
        toast.error("Error while downloading PDF");
      }
    },
    [dispatch],
  );
  return { execute, downloadPDF, pdfURL: pdfView };
};
